module.exports =
  data: ->
    template_category_options: [value: null, text: @$t('general.feedback.loading')]

  methods:
    loadTemplateCategories: ->
      new TemplateCategoriesResource(Session.current_company.id)
        .index(@loadTemplateCategoriesSuccess, null, params: {q: {s: 'name asc'}})

    getTemplateCategoriesFromStore: ->
      # Busca as template_categories no central store
      data = { template_categories: @$store.getters.templateCategoriesList }
      @loadTemplateCategoriesSuccess data

    loadTemplateCategoriesSuccess: (data) ->
      template_category_options = for template_category in data.template_categories
        { value: { template_category_id_eq: template_category.id.toString() }, text: template_category.name }

      template_category_options.unshift( value: null, text: @$t('template.label.allCategories') )

      @template_category_options = template_category_options

      # Commita as mudanças para o state do central store
      @$store.commit 'loadTemplateCategories', data.template_categories if @load_template_categories

  computed:
    load_template_categories: ->
      @$store.getters.templateCategoriesCount == 0

  created: ->
    if @load_template_categories
      @loadTemplateCategories()
    else
      @getTemplateCategoriesFromStore()



// WEBPACK FOOTER //
// ./src/mixins/template_categories_options.coffee